import { gql } from '@apollo/client';

export default gql`
  mutation overridePendingCancellationBookingPrice(
    $bookingReference: String!
    $overrideReason: String!
    $waiveRepricing: Boolean
    $waiveHotelFees: Boolean
    $waiveTrainFees: Boolean
  ) {
    overridePendingCancellationBookingPrice(
      bookingReference: $bookingReference
      overrideReason: $overrideReason
      waiveRepricing: $waiveRepricing
      waiveHotelFees: $waiveHotelFees
      waiveTrainFees: $waiveTrainFees
    ) {
      reference
    }
  }
`;
